<div class="flex flex-col h-full bg-gray-100 px-6 py-4">

    <!-- Navigation haut -->
    <div class="flex justify-between items-center mb-4">
        <button (click)="goBack()"
            class="w-12 h-12 bg-blue-700 hover:bg-blue-800 text-white rounded-sm flex items-center justify-center shadow">
            <i class="fas fa-chevron-left text-lg"></i>
        </button>
        <button (click)="goForward()"
            class="w-12 h-12 bg-gray-200 hover:bg-gray-300 text-gray-600 rounded-sm flex items-center justify-center shadow">
            <i class="fas fa-chevron-right text-lg"></i>
        </button>
    </div>

    <!-- Titre -->
    <h1 class="text-3xl font-bold text-gray-900 mb-1">{{ 'vues.ipad.visitor-type.title' | translate }}</h1>
    <p class="text-gray-500 mb-6">{{ 'vues.ipad.visitor-type.subtitle' | translate }}</p>

    <!-- Liste des types de visiteurs -->
    <div class="flex flex-col gap-3">
        @for (type of visibleVisitorTypes(); track type.key) {
        <button (click)="selectVisitorType(type.key)"
            class="flex items-center bg-white rounded-sm shadow-sm border border-gray-200 hover:bg-gray-50 transition p-3">
            <img [src]="type.image" [alt]="type.label" class="w-16 h-16 rounded-sm object-cover mr-4 shrink-0">
            <div class="flex-1 text-left">
                <h3 class="text-lg font-bold text-gray-800">{{ type.label | translate }}</h3>
                <p class="text-sm text-gray-500">{{ type.description | translate }}</p>
            </div>
            <i class="fas fa-chevron-right text-gray-400 ml-2"></i>
        </button>
        }
    </div>

    <!-- Sonnettes actives -->
    @if (activeBuzzers().length > 0) {
    <div class="mt-4">
        <h2 class="text-lg font-semibold text-gray-700 mb-2">{{ 'vues.ipad.visits.alert' | translate }}</h2>
        <div class="flex flex-col gap-3">
            @for (buzzer of activeBuzzers(); track buzzer.id) {
            <button (click)="pressBuzzer(buzzer)" [disabled]="pressing() !== null"
                class="flex items-center bg-white rounded-sm shadow-sm border border-gray-200 hover:bg-blue-50 transition p-3">
                <div class="w-16 h-16 rounded-sm bg-blue-100 flex items-center justify-center mr-4 shrink-0 overflow-hidden">
                    @if (getBuzzerImage(buzzer)) {
                    <img [src]="getBuzzerImage(buzzer)" alt="" class="w-full h-full object-cover">
                    } @else {
                    <i class="fas fa-bell text-2xl text-blue-600"></i>
                    }
                </div>
                <div class="flex-1 text-left">
                    <h3 class="text-lg font-bold text-gray-800">{{ getBuzzerSubject(buzzer) }}</h3>
                    <p class="text-sm text-gray-500">{{ getBuzzerBody(buzzer) }}</p>
                </div>
                @if (pressing() === buzzer.id) {
                <i class="fas fa-spinner fa-spin text-blue-600 ml-2"></i>
                } @else {
                <i class="fas fa-bell text-blue-400 ml-2"></i>
                }
            </button>
            }
        </div>
    </div>
    }

    <!-- Footer -->
    <div class="flex justify-between items-center mt-6">
        <button (click)="goBack()"
            class="w-12 h-12 bg-blue-700 hover:bg-blue-800 text-white rounded-sm flex items-center justify-center shadow">
            <i class="fas fa-chevron-left text-lg"></i>
        </button>

        <button (click)="goHome()" class="flex items-center gap-2 text-gray-600 hover:text-gray-800">
            <i class="fas fa-home text-lg"></i>
            <span class="text-sm">{{ 'vues.ipad.back.home' | translate }}</span>
        </button>

        <button (click)="goForward()"
            class="w-12 h-12 bg-gray-200 hover:bg-gray-300 text-gray-600 rounded-sm flex items-center justify-center shadow">
            <i class="fas fa-chevron-right text-lg"></i>
        </button>
    </div>

</div>